<div class="form-container mat-elevation-z8">
    <div class="form-group">
      <h3>Land Area</h3>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Gross SF</mat-label>
            <input matInput placeholder="SF" [(ngModel)]="grossSF" (ngModelChange)="calculateLandAreas()" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Gross Acres</mat-label>
            <input matInput placeholder="Acres" [(ngModel)]="grossAcres" (ngModelChange)="calculateLandAreas()" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Net SF</mat-label>
            <input matInput placeholder="SF" [(ngModel)]="netSF" (ngModelChange)="calculateLandAreas()" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Net Acres</mat-label>
            <input matInput placeholder="Acres" [(ngModel)]="netAcres" (ngModelChange)="calculateLandAreas()" />
          </mat-form-field>
        </div>
      </div>
      <h3>Excess Land Area</h3>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Gross SF</mat-label>
            <input matInput placeholder="SF" [value]="excessSF" />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Gross Acres</mat-label>
            <input matInput placeholder="Acres" [value]="excessAcres" />
          </mat-form-field>
        </div>
      </div>
      <h3>Total Land Area</h3>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Total SF</mat-label>
            <input matInput placeholder="SF" [value]="totalSF" disabled />
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="outline">
            <mat-label>Total Acres</mat-label>
            <input matInput placeholder="Acres" [value]="totalAcres" disabled />
          </mat-form-field>
        </div>
      </div>
    </div>
  
    <div class="form-group">
      <h3>Utilities</h3>
      <div class="utility-container">
        <div class="utility-row" *ngFor="let utility of utilities">
          <mat-form-field appearance="outline">
            <mat-label>{{utility.label}}</mat-label>
            <mat-select>
              <mat-option value="tenant">Tenant</mat-option>
              <mat-option value="owner">Owner</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Provider</mat-label>
            <input matInput placeholder="Provider" />
          </mat-form-field>
        </div>
      </div>
    </div>
  
    <div class="form-group">
      <h3>Parking Information</h3>
      <div class="parking-container">
        <div class="parking-row" *ngFor="let row of parkingRows; let i = index">
          <mat-form-field appearance="outline">
            <mat-label>Type</mat-label>
            <mat-select [(ngModel)]="row.type">
              <mat-option value="garage">Garage</mat-option>
              <mat-option value="surface">Surface</mat-option>
              <mat-option value="carport">Carport</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Number of Spaces</mat-label>
            <input type="number" matInput [(ngModel)]="row.spaces" placeholder="Number of Spaces" />
          </mat-form-field>
          <button mat-icon-button color="warn" style="margin-bottom: 2%;" (click)="removeRow(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <button mat-raised-button color="primary" style="margin-left: 9px;" (click)="addRow()">Click to add row</button>
    </div>
  </div>
  